import { render, staticRenderFns } from "./newEntry.component.vue?vue&type=template&id=0fff9961&scoped=true&"
import script from "./newEntry.component.vue?vue&type=script&lang=js&"
export * from "./newEntry.component.vue?vue&type=script&lang=js&"
import style0 from "./newEntry.component.vue?vue&type=style&index=0&id=0fff9961&lang=scss&scoped=true&"
import style1 from "./newEntry.component.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fff9961",
  null
  
)

export default component.exports